import apiClient from './client';

const normalizeEvent = (event) => {
    if (!event) return event;
    if (event.panelists && !event.Panelists) {
        event.Panelists = event.panelists;
    }
    return event;
};

const normalizeEvents = (events) => {
    if (!events) return events;
    if (Array.isArray(events)) {
        return events.map(normalizeEvent);
    }
    return normalizeEvent(events);
};

export const eventService = {
    // Get my events
    async getAll() {
        const data = await apiClient('me/events');
        const items = data.items || data;
        return normalizeEvents(items);
    },

    // Get division events
    async getDivisionEvents(divisionId) {
        let query = divisionId ? `?division=${divisionId}` : '';
        const data = await apiClient('division/events' + query);
        const items = data.items || data;
        return normalizeEvents(items);
    },

    // Get all events (DG)
    async getAllEvents() {
        const data = await apiClient('all/events');
        const items = data.items || data;
        return normalizeEvents(items);
    },
    getById: async (id) => {
        const data = await apiClient(`/events/${id}`);
        return normalizeEvent(data);
    },
    create: async (event) => {
        return await apiClient('/events', {
            method: 'POST',
            body: JSON.stringify(event),
        });
    },
    async createSubEvent(eventId, subEvent) {
        return await apiClient(`events/${eventId}/subevents`, {
            method: 'POST',
            body: JSON.stringify(subEvent)
        });
    },
    async getSubEvents(eventId) {
        return await apiClient(`events/${eventId}/subevents`);
    },
    async updateSubEvent(subEventId, payload) {
        const body = typeof payload === 'string' ? { status: payload } : payload;
        return await apiClient(`subevents/${subEventId}`, {
            method: 'PUT',
            body: JSON.stringify(body)
        });
    },
    update: async (id, eventData) => {
        return await apiClient(`/events/${id}`, {
            method: 'PUT',
            body: JSON.stringify(eventData),
        });
    },
    async linkTasks(eventId, linkedTaskIds) {
        return await apiClient(`/events/${eventId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'LINK_TASKS',
                linkedTaskIds
            })
        });
    },
    async prepareAttachment(eventId, file, category) {
        return await apiClient(`/events/${eventId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'PRESIGN_UPLOAD',
                fileName: file?.name,
                contentType: file?.type || 'application/octet-stream',
                sizeBytes: file?.size || 0,
                category
            }),
        });
    },
    async commitAttachment(eventId, attachment) {
        return await apiClient(`/events/${eventId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'COMMIT_ATTACHMENT',
                attachment
            }),
        });
    },
    async getAttachmentUrl(eventId, attachmentId, options = {}) {
        const wantsDownload = options.download ? '1' : '0';
        return await apiClient(`/events/${eventId}?attachmentId=${encodeURIComponent(attachmentId)}&download=${wantsDownload}`);
    },
    async deleteAttachment(eventId, attachmentId) {
        return await apiClient(`/events/${eventId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'DELETE_ATTACHMENT',
                attachmentId
            }),
        });
    },
    async getPlannerEvents() {
        const data = await apiClient('me/events?isPlanner=true');
        return data.items || data;
    },
    async createPlanner(event) {
        return await apiClient('/events', {
            method: 'POST',
            body: { ...event, isPlannerEvent: true }
        });
    },
    async updatePlanner(id, eventData) {
        return await apiClient(`/events/${id}`, {
            method: 'PUT',
            body: {
                action: 'UPDATE_PLANNER_EVENT',
                eventData
            }
        });
    },
    async deletePlanner(id) {
        return await apiClient(`/events/${id}`, {
            method: 'PUT',
            body: {
                action: 'DELETE_EVENT'
            }
        });
    }
};

